import * as React from 'react';
import { type Control, useController } from 'react-hook-form';
import type { ExtractStringKeys } from '../../../../../../react-commons/types/extractKeysOfType';
import type { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { Controlled_PropertyDateTimeInput } from './Controlled_PropertyDateTimeInput';

export const Form_PropertyDateTimeInput = <T extends object>({
    control,
    name,
    labelOverride,
    propertyValidationInformation,
    readOnly,
    hideLabel = false,
}: {
    control: Control<T>;
    name: ExtractStringKeys<T, false>;
    labelOverride?: string;
    readOnly: boolean;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const {
        field: { value, onChange: valueOnChange },
    } = useController({
        control,
        name,
    });

    return (
        <Controlled_PropertyDateTimeInput
            value={new Date(value)}
            readOnly={readOnly}
            propertyValidationInformation={propertyValidationInformation}
            handleChange={(newDate) => {
                valueOnChange(newDate.toISOString());
            }}
            labelOverride={labelOverride}
            hideLabel={hideLabel}
        />
    );
};